/* eslint-disable react/prop-types */
import * as React from 'react';

import { Button, ListItem, TextField, makeStyles } from '@material-ui/core';

import { useRef } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

const useStyles = makeStyles((theme) => ({
  root: {},

  userDateContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '4px',
    alignSelf: 'flex-start',
  },
  listItem: {
    padding: '6px',
    paddingRight: '8px',
    ...theme.component.commentSecondary,

    margin: '2px',
    borderRadius: '10px',
    display: 'flex',
    flexDirection: 'column',
    alignSelf: 'flex-start',
    width: 'auto',
    maxWidth: '90%',
  },
  userTitle: {
    fontWeight: 'bold',
    paddingLeft: '4px',
    fontSize: '14px',
    margin: '0px',
  },
  dateText: {
    margin: '0px',

    fontSize: '10px',
  },
  userComment: {
    alignSelf: 'flex-end',
    ...theme.component.commentMain,
  },
  commentText: {
    paddingLeft: '4px',
    fontSize: '14px',
    margin: '0px',
    width: '100%',
    overflowWrap: 'break-word',
  },
  showTranslationText: {
    paddingLeft: '4px',
    fontSize: '10px',
    margin: '0px',
    width: '100%',
    overflowWrap: 'break-word',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  listItemOverlay: {
    background: 'rgba(0,0,0,0.55)',
    color: '#fff',
    padding: '4px 8px',
    borderRadius: 8,
    maxWidth: '100%',
  },
}));

export default function CommentListItem({
  comment,
  user,
  targetsWithTranslationEnabled,
  translationsByUserLocale,
  translate,
  overlay,
}) {
  const classes = useStyles();
  const { t } = useTranslation();

  const showTranslation =
    targetsWithTranslationEnabled.includes(comment.id) &&
    translationsByUserLocale &&
    translationsByUserLocale[comment.id];

  const isCurrentUsersComment = user.id === comment.userId;

  return (
    <ListItem
      className={`${classes.listItem} ${
        isCurrentUsersComment ? classes.userComment : ''
      } ${overlay ? classes.listItemOverlay : ''}`}
    >
      <div className={classes.userDateContainer}>
        <p className={classes.userTitle}>
          {comment.user
            ? `${comment.user.firstName} ${comment.user.lastName}`
            : ''}
        </p>
        <p className={classes.dateText}>{`${moment(comment.createdAt).format(
          'L'
        )} - ${moment(comment.createdAt).format('LT')}`}</p>
      </div>
      <div></div>
      <p className={classes.commentText}>
        {!showTranslation
          ? comment.content
          : translationsByUserLocale[comment.id]}
      </p>

      {comment.contentType === 'COMMENT' &&
      comment.content.trim() &&
      !isCurrentUsersComment ? (
        <p
          className={classes.showTranslationText}
          onClick={() => translate(comment)}
        >
          {!showTranslation
            ? t('common.show_translation')
            : t('common.show_original')}
        </p>
      ) : null}
    </ListItem>
  );
}
